import { Route, Routes } from "react-router-dom";
import { ManageFutureCost, FutureCostList } from "./containers";
import { ProtectedRoute } from "../../shared";

export const FutureCostRoutes = () => {
  return (
    <Routes>
      <Route index element={<FutureCostList />} />
      <Route
        element={<ProtectedRoute allowedRoute={["future-costing-create"]} />}
      >
        <Route path="new" element={<ManageFutureCost />} />
      </Route>
    </Routes>
  );
};
